// 结算模块
const settlement = {
    path: 'settlement',
    component: () => import('@/components/RouterView'),
    meta: {title: '收益'},
    redirect: '/manage/settlement/overall',
    children: [
        {
            path: 'overall',
            component: () => import('@/views/manage/settlement/overall'),
            meta: {title: '收益'},
        },
        {
            path: 'versionTax',
            component: () => import('@/views/manage/settlement/versionTax'),
            meta: {title: '版权收益'},
        },
        {
            path: 'invoicing',
            component: () => import('@/views/manage/settlement/invoicing'),
            meta: {title: '开票流程'},
        },
        {
            path: 'detail/:id',
            component: () => import('@/views/manage/settlement/detail'),
            meta: {title: '详情'},
        },
        {
            path: 'dmhDetail/:id',
            component: () => import('@/views/manage/settlement/dmhDetail'),
            meta: {title: '详情'},
        },
    ],
};

export default settlement;
